<template>
  <v-expand-transition>
    <div>
      <!-- <div v-if="plaintiffs"> -->
      <v-card-text class="display-1">FORM RESPONSES</v-card-text>
      <div>
        <div>
          <template>
            <div>
              <app-create-matter-doc :matter="matter" :user="user" :responses="resps"></app-create-matter-doc>
            </div>
          </template>
          <!-- <v-btn @click="seeData">SEE DATA</v-btn> -->
        </div>
        <div v-for="response in resps" :key="response.link">
          <v-expand-transition>
            <v-card
              style="background-color: black; border-radius: 26px; border: 1px solid #18CAE6; max-width: 650px;"
              class="ma-auto white--text font-weight-light"
              v-if="response.formDef.responses"
            >
              <v-container>
                <v-card-text>
                  <div
                    class="ma-1 body-1 text-justify blue--text font-weight-heavy"
                    v-if="response.fullName"
                  >
                    BY:
                    <span
                      class="ma-1 body-1 text-justify white--text font-weight-light"
                    >{{ response.fullName.toUpperCase() }}</span>
                  </div>
                  <!-- <div
                class="body-1 text-left white--text font-weight-light"
                  >{{ response.fullName.toUpperCase() }}</div>-->
                  <div class="ma-1 body-1 text-justify blue--text font-weight-heavy">
                    FORM NAME:
                    <span
                      class="ma-1 body-1 text-justify white--text font-weight-light text-wrap"
                    >{{ response.formDef.formTitle.toUpperCase() }}</span>
                  </div>
                  <div class="ma-1 body-1 text-justify blue--text font-weight-heavy text-wrap">
                    CLIENT USERNAME:
                    <span
                      class="body-1 text-justify white--text font-weight-light text-wrap"
                    >{{ response.username }}</span>
                  </div>
                  <div class="ma-1 body-1 text-justify blue--text font-weight-heavy text-wrap">
                    RESPONSE DATE:
                    <span
                      class="body-1 text-justify white--text font-weight-light text-wrap"
                    >{{ response.formDef.responseDate.toUpperCase() }}</span>
                  </div>
                </v-card-text>
              </v-container>
              <v-card-actions>
                <v-btn disabled outlined rounded color="yellow" class="ma-auto">delete</v-btn>
                <v-layout row class="ma-1">
                  <template>
                    <div>
                      <app-selected-doc-form :matter="matter" :user="user" :responses="response"></app-selected-doc-form>
                    </div>
                  </template>

                  <template>
                    <div>
                      <app-create-plaintiff-doc :matter="matter" :user="user" :responses="response"></app-create-plaintiff-doc>
                    </div>
                  </template>
                  <v-btn
                    v-if="response.formDef.responses.length === 22"
                    @click="fixPlaintiffForm(response)"
                  >FIX PLAINTIFF FORM</v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-expand-transition>
        </div>
        <!-- ============================================ -->
        <div v-for="clientResponse in clientResponseList" :key="clientResponse.id">
          <v-expand-transition>
            <v-card
              style="background-color: black; border-radius: 26px; border: 1px solid #18CAE6; max-width: 650px;"
              class="ma-auto white--text font-weight-light"
              v-if="clientResponse.responseDate"
            >
              <!-- <v-card-title>BY: {{ clientResponse.partyName.toUpperCase() }}</v-card-title> -->
              <v-container>
                <v-card-text>
                  <div class="body-1 text-justify blue--text font-weight-heavy">
                    BY:
                    <span
                      class="body-1 text-justify white--text font-weight-light"
                    >{{ clientResponse.partyName.toUpperCase() }}</span>
                  </div>
                  <!-- <div
                class="title text-left white--text font-weight-light"
                  >{{ response.fullName.toUpperCase() }}</div>-->
                  <div class="body-1 text-justify blue--text font-weight-heavy">
                    FORM NAME:
                    <span
                      class="body-1 text-justify white--text font-weight-light text-wrap"
                    >{{ clientResponse.name }}</span>
                  </div>
                  <div class="body-1 text-justify blue--text font-weight-heavy text-wrap">
                    RESPONSE ID:
                    <span
                      class="body-1 text-justify white--text font-weight-light text-wrap"
                    >{{ clientResponse.id }}</span>
                  </div>
                  <div class="body-1 text-justify blue--text font-weight-heavy text-wrap">
                    RESPONSE DATE:
                    <span
                      class="body-1 text-justify white--text font-weight-light text-wrap"
                    >{{ clientResponse.responseDate.toUpperCase() }}</span>
                  </div>
                </v-card-text>
              </v-container>
              <v-card-actions>
                <v-btn
                  disabled
                  outlined
                  rounded
                  color="yellow"
                  class="ma-auto"
                  @click="goToForm(clientResponse)"
                >delete</v-btn>
                <v-layout row class="ma-1">
                  <!-- <v-btn color="yellow" outlined rounded v-on="on">VIEW AND EDIT RESPONSES</v-btn> -->

                  <template>
                    <div>
                      <app-selected-doc-form
                        :matter="matter"
                        :user="user"
                        :responses="clientResponse"
                      ></app-selected-doc-form>
                    </div>
                  </template>
                  <template>
                    <div>
                      <app-create-plaintiff-doc
                        :matter="matter"
                        :user="user"
                        :responses="clientResponse"
                      ></app-create-plaintiff-doc>
                    </div>
                  </template>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-expand-transition>
        </div>
      </div>
      <!-- </v-expand-transition> -->
    </div>
  </v-expand-transition>
</template>

<script>
/**
 * THIS COMPONENT IS NOW OBSOLETE AND REPLACED BY ViewPlaintiff...
 * when a client is sent a form from th app
 * the client gets a link, cisits the link and begins filling out the form
 * once the form is saved (when the client user clicks "next" on the form)
 * the user sees an obect within the ViewPlaintiff component.
 * this component sets up a listener on the database and when a change is made to the database
 * i.e. a form response is saved, thsi coponent gets that object and creates a card with the form infomration
 * the user can then open a component that allows the user to see and edit the responses (SelectedDocForm)
 * or the user can create the document that corresponds to the form that has been filled out by selecting (CreatePlaintiffDoc)
 *
 *
 * there is still an issue that requires me to accomodate older client objects which will soon be remedied
 * as the older client objects will be deleted from the database (there are only a few)
 *
 * also at dome point in development I stopped using th eVuex store becuase
 * it was slowing my feature development down and I needed to get this thing working
 *
 */

import firebase from "firebase";
export default {
  props: ["matter", "user"],
  data() {
    return {
      // plaintiffs: this.matter.plaintiffs
      // selectedPlaintiffs: []
      resps: [],
      clientList: [],
      clientResponseList: [],
      showResponseList: false,
      showResponses: false,
    };
  },
  computed: {
    plaintiffs() {
      return this.matter.plaintiffs;
      // let plaintiffs = this.matter.plaintiffs;
      // plaintiffs.forEach(plaintiff => {
      //   const foundPlaintiff = plaintiffs.find(
      //   plaintiff => plaintiff.plaintiffSlug === payload.matterSlug
      // );
      // if (foundMatter !== null && foundMatter !== undefined) {
      //   return;
      // } else {
      //   state.matters.push(payload);
      // }
      //   if ()
      // })
    },
    viewingResponse() {
      return this.$store.getters.responses;
    },
  },
  methods: {
    // goToForm(clienResponse) {
    // if(old) id =
    // if(new) id =

    //   console.log(id);
    //   this.$router.push({ name: "SelectedDocForm", params: { id } });
    // },
    toggleShowResponses() {
      this.showResponses = !this.showResponses;
    },
    //there was an issue with older client objects, this function is so that i could fix the issues from the UI
    //this issue will no longer exist when the older client objects are deleted from the database
    fixPlaintiffForm(response) {
      let oldResponses = response.formDef.responses;
      //add the first three questions to the list of responses(theses were mistakenly left off before)
      let newResponses = oldResponses.unshift(
        {
          text: "Please Confirm Your Date of Birth",
          model: "dateOfBirth",
          type: "date",
          response: null,
        },
        {
          text: "What was your address on November 8, 2018?",
          model: "pastAddress",
          type: "address",
          response: null,
        },
        {
          text: "What is your present address?",
          model: "presentAddress",
          type: "address",
          response: null,
        }
      );
      console.log(newResponses);
      console.log(response);
      // save the responses
      firebase
        .firestore()
        // .collection("firms")
        // .doc(this.user.firmSlug)
        .collection("matters")
        .doc(this.matter.matterSlug)
        .collection("clients")
        .doc(response.clientSlug)
        .set(response)
        .then(() => {
          console.log("fixed");
        })
        .catch((e) => {
          console.log(e.message);
        });
    },
    showList() {
      this.showResponseList = !this.showResponseList;
    },
    seeData() {
      console.log("this.resps", this.resps);
      console.log("this.clientList", this.clientList);
      console.log("this.clientResponseList", this.clientResponseList);
      console.log("this.plaintiffs", this.plaintiffs);
      console.log("this.viewingResponse", this.viewingResponse);
    },
    logResps() {
      console.log(this.resps);
    },
    //not sure why I would still need this
    viewResponse(response) {
      console.log(response);

      // let payload = {
      //   partyType: "plaintiff",
      //   party: plaintiff
      // };
      this.$store.dispatch("viewResponse", response);
    },
    //not sure why I would still need this
    cancelViewResponse() {
      this.$store.dispatch("viewResponse", null);
    },

    //NOT SURE WHY THIS IS HERE BUT COMMENTED OUT
    // deletePlaintiff(plaintiff) {
    //   // let newArray = Array.from(this.matter.plaintiffs);

    //   // //remove the doc from the array
    //   // newArray.splice(index, 1);
    //   // console.log("newArray", newArray);
    //   // console.log("oldArray", this.matter.plaintiffs);
    //   firebase
    //     .firestore()
    //     .collection("firms")
    //     .doc(this.user.firmSlug)
    //     .collection("matters")
    //     .doc(this.matter.matterSlug)
    //     .update({
    //       plaintiffs: firebase.firestore.FieldValue.arrayRemove(plaintiff)
    //     })
    //     .then(() => {
    //       console.log("success");
    //     });
    // }
  },
  created() {
    //////////////////////////////////////////////////////////////////
    let clientRef = firebase
      .firestore()
      // .collection("firms")
      // .doc(this.user.firmSlug)
      .collection("matters")
      .doc(this.matter.matterSlug)
      .collection("clients");

    //create a snapshot for the client collection
    clientRef.onSnapshot((res) => {
      const changes = res.docChanges();
      console.log("all changes", changes);
      changes.forEach((change) => {
        // console.log("change", change);
        //if a new formList item is added to the collection
        if (change.type === "added") {
          let addedClient = change.doc.data();
          if (!addedClient.formDef) {
            let existingClient = this.clientList.find(
              (client) => client.clientSlug === addedClient.clientSlug
            );
            if (existingClient !== null && existingClient !== undefined) {
              console.log("client already in list", addedClient);
              return;
            } else {
              this.clientList.push(addedClient);
              console.log("added client", addedClient);
            }
          }
          //accounting for older client obejcts
          if (addedClient.formDef) {
            console.log("OLD CLIENTS added form responses", addedClient);

            const foundResp = this.resps.find(
              (resp) => resp.link === addedClient.link
            );
            if (foundResp !== null && foundResp !== undefined) {
              return;
            } else {
              this.resps.push(addedClient);
            }
          }
          //if the formList item is modified
        } else if (change.type === "modified") {
          let modifiedClient = change.doc.data();
          let existingClient = this.clientList.find(
            (client) => client.clientSlug === modifiedClient.clientSlug
          );
          if (existingClient !== null && existingClient !== undefined) {
            console.log(
              "client already in list: replacing it now",
              existingClient
            );
            //find the index of existing client
            let index = this.clientList.indexOf(existingClient);
            this.clientList.splice(index, 1, modifiedClient);
          } else {
            this.clientList.push(modifiedClient);
            console.log("added client", modifiedClient);
          }
          //accounting for older client objects
          if (modifiedClient.formDef.responses) {
            console.log("OLD CLIENTS modified form responses", modifiedClient);
            if (this.resps.length > 0) {
              let existingResp = this.resps.find(
                (resp) => resp.link === `${modifiedClient.link}`
              );
              console.log("existing resp", existingResp);
              if (existingResp !== null && existingResp !== undefined) {
                const index = this.resps.indexOf(existingResp);
                console.log(
                  "index of existingResp that has been modified",
                  index
                );
                this.resps.splice(index, 1, modifiedClient);
              } else {
                // return;
                this.resps.push(modifiedClient);
              }
            } else {
              this.resps.push(modifiedClient);
            }
          }
        } else if (change.type === "removed") {
          let removedClient = change.doc.data();

          if (removedClient.formDef.responses) {
            const removed = change.doc.data();
            console.log("OLD CLIENT being removed", removed);
            const existingResp = this.resps.find(
              (resp) => resp.link === removed.link
            );
            const index = this.resps.indexOf(existingResp);
            this.resps.splice(index, 1);
          } else {
            console.log("client being removed", removedClient);
            const existingClient = this.clientList.find(
              (client) => client.clientSlug === removedClient.clientSlug
            );
            const index = this.clientList.indexOf(existingClient);
            this.clientList.splice(index, 1);
          }
        }
      });
    });
    // .then(() => {
    //   console.log(
    //     "doing something after the snapshot, here is the clietnResponse List",
    //     this.clientResponseList
    //   );
    // });

    // let clientResponseList = [];
    this.matter.plaintiffs.forEach((plaintiff) => {
      if (plaintiff.formList) {
        // plaintiff.formList.forEach(form => {
        let formRef = firebase
          .firestore()
          // .collection("firms")
          // .doc(this.user.firmSlug)
          .collection("matters")
          .doc(this.matter.matterSlug)
          .collection("clients")
          .doc(plaintiff.partySlug)
          .collection("formList");
        formRef.onSnapshot((res) => {
          const changes = res.docChanges();
          changes.forEach((change) => {
            if (change.type === "added") {
              const addedForm = change.doc.data();
              const existingForm = this.clientResponseList.find(
                (form) => form.id === addedForm.id
              );
              if (existingForm !== null && existingForm !== undefined) {
                console.log("client already in list", addedForm);
                return;
              } else {
                this.clientResponseList.push(addedForm);
                console.log("added form", addedForm);
              }
            } else if (change.type === "modified") {
              const modifiedForm = change.doc.data();
              const existingForm = this.clientResponseList.find(
                (form) => form.id === modifiedForm.id
              );
              if (existingForm !== null && existingForm !== undefined) {
                console.log(
                  "client already in list: replacing it now",
                  existingForm
                );
                //find the index of existing client
                let index = this.clientResponseList.indexOf(existingForm);
                this.clientResponseList.splice(index, 1, modifiedForm);
              } else {
                this.clientResponseList.push(modifiedForm);
                console.log("added form", modifiedForm);
              }
            } else if (change.type === "removed") {
              const removedForm = change.doc.data();
              console.log("form being removed", removedForm);
              const existingForm = this.clientResponseList.find(
                (form) => form.id === form.id
              );
              const index = this.clientResponseList.indexOf(existingForm);
              this.clientResponseList.splice(index, 1);
            }
          });
        });
        // });
      }
    });
  },
};
</script>

<style lang="scss" scoped></style>
